import { Divider, Heading, List } from '@apollo/orbit';
import React from 'react';

import { SubgraphsListItem } from 'src/app/graph/operationsPage/insightsL3Nav/insightsList/insightsListItem/SubgraphsListItem';
import { SelectedSubgraph } from 'src/app/graph/operationsPage/insightsL3Nav/insightsList/SubgraphsList';

interface Props extends SelectedSubgraph {
  loading: boolean;
}

export function SelectedSubgraphsListItem({
  loading,
  ...selectedSubgraphProps
}: Props) {
  return (
    <div className="pt-2">
      <Heading variant="title" className="my-2 ml-4">
        Selected
      </Heading>
      <List isInteractive className="mb-4">
        <SubgraphsListItem
          isSelected
          subgraphName={selectedSubgraphProps.name}
          hideStatsValue={true}
          loading={loading}
          {...selectedSubgraphProps}
        />
      </List>
      <Divider />
    </div>
  );
}
